// M3 economy & politics (M3_SPEC §7-§9, §13-§16): shared state helpers and gating. The daily entry point and the
// hooks other sim files call live in econtick.js; the mechanics in fiscal / routes / leaserounds / hedging / regimes /
// nationalize.js. Everything is inert before 1 Jan 1946 (no RNG draws, no money moves), so M1/M2 games are untouched.
import { wellsOnField } from '../indexes.js';
import { M3_FROM } from '../../data/m3/rules.js';
import { yf } from '../defs.js';

export { M3_FROM };
export const m3On = (state) => yf(state) >= M3_FROM;

export function econState(state) {
  const e = (state.m3econ ??= {});
  e.nat ??= { applied: {}, buyback: {} };
  e.nat.applied ??= {}; e.nat.buyback ??= {};
  e.concessions ??= {};
  e.licences ??= {};
  e.routes ??= {};
  e.embargoes ??= [];
  e.regimes ??= {};
  e.safetyCases ??= {};
  e.inspections ??= {};
  e.fiscalMonths ??= {};
  e.fires ??= {};
  e.fireContracts ??= [];
  e.shutIns ??= {};
  return e;
}

// US-domiciled by default (M2 taxes assume it too). Libya 1986 and the foreign tax credit read it.
export const isUsCompany = (state) => (state.company.domicile ?? 'us') === 'us';

export function bumpStat(state, key, n = 1) {
  const s = state.company.stats;
  s[key] = (s[key] ?? 0) + n;
  return s[key];
}

export const GONE = new Set(['SEIZED', 'PLUGGED', 'HANDED_OVER', 'DRY', 'ABANDONED']);
export const liveWell = (w) => !GONE.has(w.status) && !w.ownerOperatorId;

// Player wells currently producing in a field (rate today > 0).
export function producingWells(state, fieldId) {
  return wellsOnField(state, fieldId).filter((w) => w.status === 'PRODUCING' && w.prod && !w.ownerOperatorId); // perf: field index
}

export const round2 = (x) => Math.round(x * 100) / 100;
